<script>
  import { GQLNow } from "gql-now";
  import { onMount } from "svelte";
  import { PKClient } from "../services/PKClient";
  import { CSVDownloader } from "svelte-csv";
  import moment from "moment";
  import {
    App,
    f7,
    f7ready,
    Card,
    CardFooter,
    CardContent,
    CardHeader,
    Page,
    Navbar,
    NavLeft,
    NavTitle,
    NavTitleLarge,
    NavRight,
    Link,
    Toolbar,
    Block,
    BlockTitle,
    List,
    ListItem,
    Row,
    Col,
    Button,
    Gauge,
    AreaChart,
    Panel,
    Menu,
    MenuItem,
    MenuDropdown,
    MenuDropdownItem,
    Icon,
    Searchbar,
    AccordionContent,
  } from "framework7-svelte";
  import { handleUnauthorized } from "../js/auth";
  import { fetchAdminNavigation, navSections, quickActions, navLoading } from "../js/navigationStore";

  export let f7route;
  export let f7router;
  let analytics;
  let incomplete, pending, approved, added_money, not_added_money;
  let admin_access_token;
  let approved_ucc_filename =
    "trdr_approved_users_" + moment().format("DD-MM-YYYY");
  let home_filename = "trdr_homedata_" + moment().format("DD-MM-YYYY");
  let logs_filename = "trdr_logs_" + moment().format("DD-MM-YYYY");
  let approved_ucc, homedata;
  let login_logs;
  onMount(() => {
    f7ready(async () => {
      admin_access_token = localStorage.getItem("token");
      if (!admin_access_token) {
        handleUnauthorized(f7, f7router);
        return;
      }
      fetchAdminNavigation();
      await fetch_user_analytics();
    });
  });
  function user_info() {
    navigateTo(`/user-info/`);
  }

  function navigateTo(url) {
    if (!url) return;
    try {
      if (f7router && typeof f7router.navigate === "function") {
        f7router.navigate(url);
        return;
      }
      if (f7 && f7.views && f7.views.main && f7.views.main.router) {
        f7.views.main.router.navigate(url);
        return;
      }
      if (f7 && f7.view && f7.view.main && f7.view.main.router) {
        f7.view.main.router.navigate(url);
        return;
      }
    } catch (e) {
      console.warn("Navigation failed, falling back to window location", e);
    }
    window.location.href = url;
  }

  function convert_date(timestamp) {
    let final_date = moment(new Date(Number(timestamp))).format("DD-MM-YYYY");
    return final_date;
  }

  const fetch_user_analytics = async () => {
    let obj = new GQLNow(`https://api.trdr.money/graphql/trdr-admin-services`, {
      "x-trdr-org": "60e6cd9df9c32f00072b71f8",
      "x-access-token": admin_access_token,
    });
    try {
      console.log("calling cashfree api...");
      let response = await obj.query(
        "user_analytics",
        {},
        "status incomplete pending approved added_money not_added_money"
      );
      //console.log("\n\n Analytics Data:", response);
      analytics = response.data.user_analytics;
      console.log("Analytics:", analytics);
      approved = analytics.approved;
      pending = analytics.pending;
      incomplete = analytics.incomplete;
      added_money = analytics.added_money;
      not_added_money = analytics.not_added_money;

      let ucc_res = await obj.query(
        "fetch_all_users",
        { category: "approved" },
        "all_users{ucc}"
      );
      console.log("UCC Response:", ucc_res);
      approved_ucc = ucc_res.data.fetch_all_users.all_users;

      let homedata_res = await obj.query(
        "get_all_users_homepage_data",
        {},
        "all_home_data {user_name mobile ucc portfolio_value ledger_balance dp_holding_value ledger_balance_type dp_total_value previous_longshort_value longshort_value investment_amount payout_amount profit_loss_amount performance_percentage account_opening_date first_transaction_date}"
      );
      homedata = homedata_res.data.get_all_users_homepage_data.all_home_data;

      let user_login_logs = await obj.query(
        "get_all_signin_logs",
        {},
        "signin_logs {ucc full_name logged_in_ts}"
      );
      login_logs = user_login_logs.data.get_all_signin_logs.signin_logs;
      for (let i = 0; i < login_logs.length; i++) {
        let ts = login_logs[i].logged_in_ts;
        if (ts.length === 13) {
          login_logs[i].logged_in_ts = convert_date(login_logs[i].logged_in_ts);
        }
      }

      console.log(login_logs);
    } catch (err) {
      console.log({ gen_otp_error: err });
      let errMsg = "";
      if (err && err.data && err.data.errors && err.data.errors.length > 0) {
        errMsg = err.data.errors[0].message || "";
      } else if (err && err.message) {
        errMsg = err.message;
      } else if (typeof err === "string") {
        errMsg = err;
      }
      if (
        errMsg.includes("Access Denied") ||
        errMsg.includes("Unauthorized") ||
        errMsg.includes("authenticate token") ||
        errMsg.includes("Member not found")
      ) {
        handleUnauthorized(f7, f7router, "Invalid credentials or session expired");
      } else {
        f7.dialog.alert(errMsg || "An error occurred");
      }
    }
  };
</script>

<Page class="admin-home">
  <!-- Top Navbar -->
  <Navbar
    large
    style="--f7-navbar-bg-color: white;
    --f7-navbar-text-color: black;
    --f7-navbar-link-color: black;"
    sliding={false}
  >
    <NavLeft>
      <Link
        iconIos="f7:menu"
        iconAurora="f7:menu"
        iconMd="material:menu"
        panelOpen="#panel-left"
      />
      <Link
        searchbarEnable=".searchbar-demo"
        iconIos="f7:search"
        iconAurora="f7:search"
        iconMd="material:search"
      />
    </NavLeft>
    <!-- <NavTitle>Admin Dashboard</NavTitle> -->

    <NavRight>
      <Link>
        <p class="title-text">URL:desk.trdr.money</p>
      </Link>
      <Link
        iconIos="f7:bell_fill"
        iconAurora="f7:bell_fill"
        iconMd="f7:bell_fill"
      />
      <Link
        iconIos="f7:question_circle"
        iconAurora="f7:question_circle"
        iconMd="f7:question_circle"
      />
      <Link
        iconIos="f7:person_alt_circle"
        iconAurora="f7:person_alt_circle"
        iconMd="f7:person_alt_circle"
      />
    </NavRight>

    <NavTitleLarge>Admin Dashboard</NavTitleLarge>

    <Searchbar
      class="searchbar-demo"
      expandable
      searchContainer=".search-list"
      searchIn=".item-title"
      disableButton
      disableButtonText
      clearButton
    />
  </Navbar>
  <!-- Toolbar 
  <Toolbar bottom>
    <Link>Left Link</Link>
    <Link>Right Link</Link>
  </Toolbar> -->
  <!-- Page content 
  <Block strong>
    <p>Here is your blank Framework7 app. Let's see what we have here.</p>
  </Block> -->

  <div class="page-content padding">
    <!-- Hero Banner: Operational Transformation & SSOT Guide -->
    <Block style="margin-top: 5px; margin-bottom: 20px;">
      <div
        class="card"
        style="background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%); color: #ffffff; border-radius: 12px; box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.25); overflow: hidden; border: 1px solid #334155;"
      >
        <div style="padding: 24px;">
          <div style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 14px;">
            <div>
              <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px; flex-wrap: wrap;">
                <span style="background: #2563eb; color: #fff; font-size: 11px; font-weight: 700; padding: 2px 8px; border-radius: 9999px; text-transform: uppercase; letter-spacing: 0.05em;">NEW</span>
                <span style="background: rgba(255,255,255,0.12); color: #cbd5e1; font-size: 11px; font-weight: 600; padding: 2px 8px; border-radius: 9999px;">v2.1.0 SSOT</span>
                <span style="color: #94a3b8; font-size: 12px;">Ref: How to_ TRDR Admin API's.docx</span>
              </div>
              <h2 style="margin: 0 0 6px 0; font-size: 21px; font-weight: 700; color: #ffffff; letter-spacing: -0.02em;">
                TRDR Back-Office Operations: Manual vs. Automated System Guide
              </h2>
              <p style="margin: 0; color: #94a3b8; font-size: 13px; max-width: 800px; line-height: 1.5;">
                Operational & executive transformation guide detailing user approvals, direct FCML broker onboarding, automated 16-digit CDSL demat synthesis, and zero-trust audit compliance. Featuring visual Before-vs-Now comparisons and WhatsApp evidence.
              </p>
            </div>
            <Button
              fill
              large
              color="blue"
              onClick={() => f7router.navigate("/system-docs/")}
              style="font-weight: 600; padding: 0 22px; height: 42px; display: inline-flex; align-items: center; gap: 6px; box-shadow: 0 4px 12px rgba(37, 99, 235, 0.35);"
            >
              📖 Explore System Ops Guide →
            </Button>
          </div>

          <!-- Quick Metrics Bar -->
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 12px; margin-top: 20px; padding-top: 18px; border-top: 1px solid rgba(255,255,255,0.1);">
            <div style="background: rgba(255,255,255,0.05); padding: 10px 14px; border-radius: 8px;">
              <div style="color: #60a5fa; font-size: 11px; font-weight: 600; text-transform: uppercase;">Zero-Trust PII</div>
              <div style="font-size: 18px; font-weight: 700; color: #fff;">100% Protected</div>
            </div>
            <div style="background: rgba(255,255,255,0.05); padding: 10px 14px; border-radius: 8px;">
              <div style="color: #34d399; font-size: 11px; font-weight: 600; text-transform: uppercase;">Demat Math Errors</div>
              <div style="font-size: 18px; font-weight: 700; color: #fff;">0% Error Rate</div>
            </div>
            <div style="background: rgba(255,255,255,0.05); padding: 10px 14px; border-radius: 8px;">
              <div style="color: #fbbf24; font-size: 11px; font-weight: 600; text-transform: uppercase;">Turnaround Time</div>
              <div style="font-size: 18px; font-weight: 700; color: #fff;">95% Faster</div>
            </div>
            <div style="background: rgba(255,255,255,0.05); padding: 10px 14px; border-radius: 8px;">
              <div style="color: #c084fc; font-size: 11px; font-weight: 600; text-transform: uppercase;">Audit Readiness</div>
              <div style="font-size: 18px; font-weight: 700; color: #fff;">100% Reconciled</div>
            </div>
          </div>
        </div>
      </div>
    </Block>

    <!-- Hero Banner: F1F2 to TRDR Autopilot Migration Guide -->
    <Block style="margin-top: -5px; margin-bottom: 20px;">
      <div
        class="card"
        style="background: linear-gradient(135deg, #0b0f19 0%, #1e1b4b 60%, #0f172a 100%); color: #ffffff; border-radius: 12px; box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.35); overflow: hidden; border: 1px solid #3b4252;"
      >
        <div style="padding: 24px;">
          <div style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 14px;">
            <div>
              <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px; flex-wrap: wrap;">
                <span style="background: #ea580c; color: #fff; font-size: 11px; font-weight: 700; padding: 2px 8px; border-radius: 9999px; text-transform: uppercase; letter-spacing: 0.05em;">AUTOPILOT</span>
                <span style="background: #2563eb; color: #fff; font-size: 11px; font-weight: 700; padding: 2px 8px; border-radius: 9999px; text-transform: uppercase;">NEW</span>
                <span style="background: rgba(255,255,255,0.12); color: #cbd5e1; font-size: 11px; font-weight: 600; padding: 2px 8px; border-radius: 9999px;">v3.0.0 SSOT</span>
                <span style="color: #fb923c; font-size: 12px; font-weight: 600;">trdr-engine Daemon Architecture</span>
              </div>
              <h2 style="margin: 0 0 6px 0; font-size: 21px; font-weight: 700; color: #ffffff; letter-spacing: -0.02em;">
                F1F2 to TRDR Autopilot Migration Guide
              </h2>
              <p style="margin: 0; color: #94a3b8; font-size: 13px; max-width: 800px; line-height: 1.5;">
                From 50 open browser tabs with setInterval to a 24/7 autonomous background Go daemon, prime-stride fair rotational queues, dynamic H/M/L lot sizing, and a unified 1,000+ UCC dealer terminal.
              </p>
            </div>
            <Button
              fill
              large
              color="orange"
              onClick={() => f7router.navigate("/f1f2-migration-guide/")}
              style="font-weight: 600; padding: 0 22px; height: 42px; display: inline-flex; align-items: center; gap: 6px; box-shadow: 0 4px 12px rgba(234, 88, 12, 0.4);"
            >
              🚀 Explore Autopilot Guide →
            </Button>
          </div>

          <!-- Quick Metrics Bar -->
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 12px; margin-top: 20px; padding-top: 18px; border-top: 1px solid rgba(255,255,255,0.1);">
            <div style="background: rgba(255,255,255,0.05); padding: 10px 14px; border-radius: 8px;">
              <div style="color: #60a5fa; font-size: 11px; font-weight: 600; text-transform: uppercase;">Browser Tabs</div>
              <div style="font-size: 18px; font-weight: 700; color: #fff;">0 Tabs Needed</div>
            </div>
            <div style="background: rgba(255,255,255,0.05); padding: 10px 14px; border-radius: 8px;">
              <div style="color: #34d399; font-size: 11px; font-weight: 600; text-transform: uppercase;">Cloud Autopilot</div>
              <div style="font-size: 18px; font-weight: 700; color: #fff;">100% 24/7 Go</div>
            </div>
            <div style="background: rgba(255,255,255,0.05); padding: 10px 14px; border-radius: 8px;">
              <div style="color: #fb923c; font-size: 11px; font-weight: 600; text-transform: uppercase;">Concurrent Scale</div>
              <div style="font-size: 18px; font-weight: 700; color: #fff;">1,000+ UCCs</div>
            </div>
            <div style="background: rgba(255,255,255,0.05); padding: 10px 14px; border-radius: 8px;">
              <div style="color: #2dd4bf; font-size: 11px; font-weight: 600; text-transform: uppercase;">Dispatch Latency</div>
              <div style="font-size: 18px; font-weight: 700; color: #fff;">&lt; 50ms Fair Queue</div>
            </div>
          </div>
        </div>
      </div>
    </Block>

    <!-- Quick Navigation Actions Bar -->
    <Block style="margin-top: 0; margin-bottom: 20px;">
      <div style="display: flex; gap: 10px; flex-wrap: wrap; align-items: center;">
        <span style="font-size: 12px; font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: 0.05em; margin-right: 4px;">Quick Access:</span>
        {#each $quickActions as action}
          <Button
            small
            outline
            color={action.color || "blue"}
            onClick={() => f7router.navigate(action.route)}
            style="display: inline-flex; align-items: center; gap: 4px; border-radius: 6px; font-weight: 600;"
          >
            {action.title}
            {#if action.badge}
              <span style="background: {action.badge === 'NEW' ? '#2563eb' : action.badge === 'ACTION' ? '#059669' : '#ea580c'}; color: #fff; font-size: 9px; padding: 1px 5px; border-radius: 4px; font-weight: 700; margin-left: 2px;">
                {action.badge}
              </span>
            {/if}
          </Button>
        {/each}
      </div>
    </Block>

    <BlockTitle large class="padding-left padding-top"
      >User Analytics</BlockTitle
    >
    <Block>
      <div class="card data-table hoverTable">
        <div style="padding:15px">
          Approved Users: {approved}<br />
          Pending Users: {pending}<br />
          Incomplete Users: {incomplete}<br /><br />
          Total Users: {Number(approved) +
            Number(incomplete) +
            Number(pending)}<br />
        </div>
      </div>
    </Block>

    <Block>
      <div class="card data-table hoverTable">
        <div style="padding:15px">
          Users who added money: {added_money}<br />
          Approved users who didn't added money: {not_added_money}<br />
        </div>
      </div>
    </Block>

    <Block>
      <div class="card data-table hoverTable" style="background: linear-gradient(135deg, #2563eb15 0%, #1d4ed820 100%); border: 1px solid #2563eb40;">
        <div style="padding:15px">
          <h3 style="margin-top:0; color:#1d4ed8; display: flex; align-items: center; gap: 8px;">
            📖 System Knowledge & Governance Hub
          </h3>
          <p style="color:#64748b; font-size:13px; margin-bottom:14px;">
            Architectural transformation manuals, 50-tab autopilot blueprints, broker compliance guides, and zero-trust audit docs.
          </p>
          <div style="display: flex; flex-wrap: wrap; gap: 8px;">
            <Button fill small color="blue" onClick={() => f7router.navigate("/system-docs/")}>
              📘 Broker & Back-Office Ops Guide
            </Button>
            <Button fill small color="orange" onClick={() => f7router.navigate("/f1f2-migration-guide/")}>
              🚀 F1F2 Autopilot Migration Guide
            </Button>
            <Button outline small color="black" onClick={() => f7router.navigate("/dealer-terminal/")}>
              ⚡ Live Dealer Terminal
            </Button>
            <Button outline small color="black" onClick={() => f7router.navigate("/strategy-manager/")}>
              🎯 Strategy & Risk Manager
            </Button>
            <Button outline small color="black" onClick={() => f7router.navigate("/master-data-manager/")}>
              📁 Scrip Master
            </Button>
            <Button outline small color="black" onClick={() => f7router.navigate("/bse-conformance/")}>
              🛡️ BSE Conformance
            </Button>
          </div>
        </div>
      </div>
    </Block>

    <Block>
      <div class="card data-table hoverTable" style="background: linear-gradient(135deg, #10b98115 0%, #05966920 100%); border: 1px solid #10b98140;">
        <div style="padding:15px">
          <h3 style="margin-top:0; color:#059669; display: flex; align-items: center; gap: 8px;">
            📊 Trading & Dealer Execution Hub
          </h3>
          <p style="color:#64748b; font-size:13px; margin-bottom:14px;">
            Direct access to live order books, quant strategy allocation, scrip masters, and bulk tools.
          </p>
          <div style="display: flex; flex-wrap: wrap; gap: 8px;">
            <Button fill small color="green" onClick={() => f7router.navigate("/dealer-terminal/")}>
              ⚡ Intraday Trading
            </Button>
            <Button fill small color="purple" onClick={() => f7router.navigate("/user-trading-controls/")}>
              👤 Client Controls
            </Button>
            <Button fill small color="blue" onClick={() => f7router.navigate("/strategy-manager/")}>
              🎯 Strategy & Risk Manager
            </Button>
            <Button outline small color="black" onClick={() => f7router.navigate("/master-data-manager/")}>
              📁 Scrip Master
            </Button>
            <Button outline small color="black" onClick={() => f7router.navigate("/market-calendar/")}>
              📅 Market Calendar
            </Button>
            <Button outline small color="black" onClick={() => f7router.navigate("/dealer-bulk-orders/")}>
              📋 Bulk Orders CSV
            </Button>
            <Button outline small color="black" onClick={() => f7router.navigate("/mutual-fund-portfolio/")}>
              📈 Mutual Funds & SIPs
            </Button>
            <Button fill small color="pink" onClick={() => f7router.navigate("/admin-users-list/")}>
              🛡️ Admin Users List
            </Button>
          </div>
        </div>
      </div>
    </Block>

    <!-- User Management & Approvals Hub -->
    <Block>
      <div class="card data-table hoverTable" style="background: linear-gradient(135deg, #3b82f615 0%, #1d4ed815 100%); border: 1px solid #3b82f640;">
        <div style="padding:15px">
          <h3 style="margin-top:0; color:#1d4ed8; display: flex; align-items: center; gap: 8px;">
            👥 User Management, FCML Onboarding & CDSL Allocation
          </h3>
          <p style="color:#64748b; font-size:13px; margin-bottom:14px;">
            Single-click FCML broker onboarding, targeted mobile lookup, 16-digit CDSL demat generation, and eSign dispatch.
          </p>
          <div style="display: flex; flex-wrap: wrap; gap: 8px;">
            <Button fill small color="blue" onClick={() => f7router.navigate("/approve-account/")}>
              ✨ Approve Account & FCML
            </Button>
            <Button outline small color="blue" onClick={() => f7router.navigate("/users/")}>
              🗂️ All Users Directory
            </Button>
            <Button outline small color="green" onClick={() => f7router.navigate("/approved-users/")}>
              ✅ Approved Users
            </Button>
            <Button outline small color="orange" onClick={() => f7router.navigate("/pending-users/")}>
              ⏳ Pending Approvals
            </Button>
            <Button outline small color="red" onClick={() => f7router.navigate("/incomplete-users/")}>
              ⚠️ Incomplete Signups
            </Button>
            <Button outline small color="purple" onClick={() => f7router.navigate("/verify-penny-drop/")}>
              🪙 Penny Drop Verify
            </Button>
          </div>
        </div>
      </div>
    </Block>

    <!-- Financial Audits & Risk Controls Hub -->
    <Block>
      <div class="card data-table hoverTable" style="background: linear-gradient(135deg, #8b5cf615 0%, #6d28d915 100%); border: 1px solid #8b5cf640;">
        <div style="padding:15px">
          <h3 style="margin-top:0; color:#6d28d9; display: flex; align-items: center; gap: 8px;">
            💳 Financial Audits, Reconciliation & Risk Leaks
          </h3>
          <p style="color:#64748b; font-size:13px; margin-bottom:14px;">
            Blacklist-filtered Cashfree payments, real-time client ledger health, leverage drawdown monitoring, and multi-report tax hubs.
          </p>
          <div style="display: flex; flex-wrap: wrap; gap: 8px;">
            <Button fill small color="purple" onClick={() => f7router.navigate("/cashfree-transactions/")}>
              🧾 Cashfree Payment Audits
            </Button>
            <Button fill small color="orange" onClick={() => f7router.navigate("/all-users-home-data/")}>
              🚨 Client Financial Health & AUM
            </Button>
            <Button fill small color="teal" onClick={() => f7router.navigate("/all-reports-of-user/")}>
              📑 Unified Multi-Report Hub
            </Button>
            <Button outline small color="black" onClick={() => f7router.navigate("/withdraw-requests/")}>
              💸 Withdrawal Requests
            </Button>
            <Button outline small color="black" onClick={() => f7router.navigate("/all-enach/")}>
              🔄 ENACH Mandates & Debits
            </Button>
          </div>
        </div>
      </div>
    </Block>

    <Block>
      <div class="card data-table hoverTable" style="background: linear-gradient(135deg, #6366f115 0%, #4338ca15 100%); border: 1px solid #6366f140;">
        <div style="padding:15px; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px;">
          <div>
            <h3 style="margin:0 0 4px 0; color:#4338ca;">🛡️ Organization Administrators</h3>
            <p style="color:#64748b; font-size:13px; margin:0;">View authorized admin accounts, emails, mobile numbers, UCC mappings, and roles.</p>
          </div>
          <Button fill small color="indigo" onClick={() => f7router.navigate("/admin-users-list/")}>
            View Admin Directory →
          </Button>
        </div>
      </div>
    </Block>

    <Block>
      <div class="card data-table hoverTable" style="background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%); border: 1px solid #667eea40;">
        <div style="padding:15px">
          <h3 style="margin-top:0; color:#4f46e5;">👥 Referrals & Growth</h3>
          <p style="color:#64748b; font-size:13px; margin-bottom:12px;">Track who referred whom, promoter champions, conversion rates, and referral AUM.</p>
          <Button fill small color="blue" onClick={() => f7router.navigate("/referrals/")} style="display:inline-block;">
            View Referrals Dashboard →
          </Button>
        </div>
      </div>
    </Block>

    <Block>
      <div class="card data-table hoverTable">
        <div style="padding:15px">
          <h3>{moment().format("DD-MM-YYYY")}</h3>
          <CSVDownloader data={approved_ucc} {approved_ucc_filename} bom={true}>
            <h4>Download Approved UCC</h4>
          </CSVDownloader> <br />

          <CSVDownloader data={homedata} {home_filename} bom={true}>
            <h4>Download Homedata</h4>
          </CSVDownloader> <br />

          <CSVDownloader data={login_logs} {logs_filename} bom={true}>
            <h4>User's logged in today</h4>
          </CSVDownloader>
        </div>
      </div>
    </Block>
  </div>
</Page>

<style>
  :global(.demo-card-header-pic .card-header) {
    height: 40vw;
    background-size: cover;
    background-position: center;
    color: #fff;
  }
  :global(.demo-card-header-pic .card-content-padding .date) {
    color: #8e8e93;
  }
  :global(.title-text) {
    position: relative;
    overflow: hidden;
    margin: 0;
    white-space: var(--f7-block-title-white-space);
    text-overflow: ellipsis;
    text-transform: var(--f7-block-title-text-transform);
    color: var(--f7-block-title-text-color);
    font-size: var(--f7-block-title-font-size, inherit);
    font-weight: var(--f7-block-title-font-weight);
    line-height: var(--f7-block-title-line-height);
  }
  .hoverTable {
    width: 100%;
    border-collapse: collapse;
  }
  .hoverTable th {
    background-color: #000;
    color: #fff;
  }
  .hoverTable tr:hover {
    background-color: #000;
    color: #fff;
  }
</style>
